import { createFileRoute, redirect } from '@tanstack/react-router'
import { prefetchProductImages } from '@/lib/prefetch-product-images'
import { orgProduct } from '@/lib/queries/org-products'
import { OrgProductDetailPage } from '@/features/organizations/products/org-product-detail'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/products/$productId'
)({
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.query({
        ...orgProduct.findOne(params.productId),
        staleTime: 'static',
      })
    } catch {
      throw redirect({
        to: '/org/$orgId/products',
        params: { orgId: params.orgId },
        replace: true,
      })
    }

    // Prefetch images (non-blocking fallback — hover preload usually handles this)
    prefetchProductImages(context.queryClient, params.productId).catch(() => {})
  },
  component: OrgProductDetailPage,
})
